// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"487":"b40e690e","878":"a41a138c"}[chunkId] + ".chunk.js";
};